/* eslint-disable consistent-return */
/* eslint-disable no-undef */
import _ from 'lodash';

export const getFacebook = () =>
  _.get(window, 'FB', { error: true, details: 'facebook not found' });

export async function getLoginStatus({
  handleNotAuthorized,
  handleConnected,
  handleNotLoggedIn,
  handleFacebookNotFound,
}) {
  return new Promise((resolve, reject) => {
    const FB = getFacebook();
    const FBError = _.get(FB, 'error', false);
    if (FBError) {
      if (handleFacebookNotFound) return handleFacebookNotFound({ resolve, reject });
      reject(FBError);
    }
    FB.getLoginStatus(response => {
      const status = _.get(response, 'status');
      if (status === 'connected') {
        // the user is logged in and has authenticated your
        // app, and response.authResponse supplies
        // the user's ID, a valid access token, a signed
        // request, and the time the access token
        // and signed request each expire
        if (handleConnected) return handleConnected({ resolve, reject });
        resolve(status);
      } else if (status === 'not_authorized') {
        // the user is logged in to Facebook,
        // but has not authenticated your app
        if (handleNotAuthorized) return handleNotAuthorized({ resolve, reject });
        reject(status);
      } else {
        // the user isn't logged in to Facebook.
        if (handleNotLoggedIn) return handleNotLoggedIn({ resolve, reject });
        reject(status);
      }
    });
  });
}

export async function login({ handleLogin = null }) {
  return new Promise((resolve, reject) => {
    const FB = getFacebook();
    const FBError = _.get(FB, 'error');
    if (FBError) reject(FBError);
    FB.login(
      loginResponse => {
        const authResponse = _.get(loginResponse, 'authResponse');

        if (authResponse) {
          if (handleLogin) return handleLogin({ data: loginResponse, resolve, reject });
          return resolve(loginResponse);
        }
        const error = 'User cancelled login or did not fully authorize.';
        _.merge(loginResponse, { error });
        if (handleLogin) return handleLogin({ data: loginResponse, resolve, reject });
        return reject(loginResponse);
      },
      {
        scope: 'email',
        auth_type: 'rerequest',
      },
    );
  });
}
